import useGetNotificationCount from './useGetNotificationCount';

export default useGetNotificationCount;
export * from './useGetNotificationCount';
